//@ts-nocheck
'use client'

import React, { useContext } from 'react'
import Image from 'next/image'

import { SpacerBase } from '../../atoms/GridSystem'
import { Paragraph, Heading } from '../../atoms/Typography/Typography.component'
import LinkWrapper from '../../atoms/LinkWrapper/LinkWrapper.component'
import Tag from '../../atoms/Tag/Tag.component'
import { MouseContext } from '../../../contexts/Mouse.context'
import { NormalizedCardUseCasesData } from '../../../models/molecules/CardUseCases'

import * as S from './CardUseCases.styles'

const CardUseCases = ({ title, description, href, image, tags, colorScheme, withBackground, parentColorScheme }: NormalizedCardUseCasesData) => {
  const { cursorChangeHandler, cursorChangeText, cursorChangeColorScheme } = useContext(MouseContext)

  return (
    <LinkWrapper href={`${href}`}>
      <S.CardUseCases colorScheme={colorScheme} withBackground={withBackground} parentColorScheme={parentColorScheme}>
        <S.CardUseCasesImage
          onMouseEnter={() => {
            cursorChangeHandler("hovered");
            cursorChangeColorScheme(colorScheme);
          }}
          onMouseLeave={() => {
            cursorChangeHandler("");
            cursorChangeColorScheme(null);
          }}
        >
          <Image src={image?.src} alt={image?.alt} fill />
          <S.CardUseCasesTag colorScheme={colorScheme}>
            <Tag items={tags} />
          </S.CardUseCasesTag>
          <S.CardUseCasesBackdrop />
        </S.CardUseCasesImage>
        <SpacerBase xs={2} />
        <Heading content={title} typo={'headingMD'} weight={'medium'} />
        <SpacerBase xs={2} />
        <Paragraph content={description} typo={'paragraphMD'} />
      </S.CardUseCases>
    </LinkWrapper>
  )
}

export default CardUseCases
